export enum InventoryQualityTableColumns {
  DOMAIN = 'domain',
  CATEGORY = 'category',
  BRAND_IMPRESSIONS = 'impressions',
  VIEWABILITY = 'viewability',
  ATTENTION = 'attention',
  REFRESH_INTERVAL = 'refreshInterval',
  DENSITY = 'density',
  CLUTTER = 'clutter',
  CLICK_RISK = 'clickRisk',
  CPM = 'cpm',
  CTR = 'ctr'
}

export enum ClickRisk {
  LOW = 'Low',
  MEDIUM = 'Medium',
  HIGH = 'High'
}

export type InventoryQualityTableRow = {
  domain: string,
  category: string,
  impressions: number,
  viewability: number,
  attention: number
  refreshInterval: number,
  density: number,
  clickRisk: ClickRisk,
  cpm: number
  ctr?: number;
}

export type SortFieldType = 'domain' | 'category' | 'impressions' | 'ctr' | 'viewability' | 'attention' | 'refreshInterval' | 'density' | 'clutter' | 'cpm'

const validSortFields: SortFieldType[] = [
  'domain',
  'category',
  'impressions',
  'ctr',
  'viewability',
  'attention',
  'refreshInterval',
  'density',
  'clutter',
  'cpm',
];

export function isSortField(value: string): value is SortFieldType {
  return validSortFields.includes(value as SortFieldType);
}
